var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144.96 76.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "120.75 17.48 109.95 6.64 116.59 0 127.43 10.8 138.28 0 144.96 6.64 134.12 17.48 144.96 28.33 138.28 35.01 127.43 24.16 116.59 35.01 109.95 28.33 120.75 17.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,75.31V1.6H9.37l17.93,42V1.6H38.4V75.31H29.48l-18-44V75.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.61,76.31q-7.81,0-12.46-2.91A16.09,16.09,0,0,1,50.5,65a37.69,37.69,0,0,1-2-12.93V24.53a36.45,36.45,0,0,1,2-12.78A15.7,15.7,0,0,1,57.15,3.6Q61.79.78,69.61.78q8,0,12.61,2.82a16,16,0,0,1,6.64,8.15,35.49,35.49,0,0,1,2,12.78V52.19a36,36,0,0,1-2,12.79,16.62,16.62,0,0,1-6.64,8.37Q77.62,76.3,69.61,76.31Zm0-9.92c2.25,0,3.9-.48,5-1.46a7.3,7.3,0,0,0,2.14-4,26.11,26.11,0,0,0,.55-5.55V21.44a25.2,25.2,0,0,0-.55-5.55A7,7,0,0,0,74.57,12q-1.59-1.41-5-1.41A7.2,7.2,0,0,0,64.79,12a6.89,6.89,0,0,0-2.18,3.87,25.2,25.2,0,0,0-.55,5.55V55.38a29.14,29.14,0,0,0,.5,5.55,6.94,6.94,0,0,0,2.14,4A7.15,7.15,0,0,0,69.61,66.39Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/NO.5805204d5a70e07bba9db3a9268de283.svg";
export { ForwardRef as ReactComponent };